import copy from "../../image/copy.svg";
import './CheckLink.scss'

export const CheckLink = ({ id }: { id?: string }) => {
    const handleCopy = () => {
        navigator.clipboard.writeText(`${window.location.origin}/organizer_event/${id}/scanner`);
    }

    return <div className="sign-in-scanner">
        <span className="sign-in-scanner__title">Вход в сканер билетов без авторизации</span>
        <div className="sign-in-scanner__content">
            <span className="sign-in-scanner__content__link">
                {`${window.location.origin}/organizer_event/${id}/scanner`}
            </span>
            <button className="sign-in-scanner__content__button"
                    onClick={handleCopy}>
                <img src={copy} alt="copy"/>
            </button>
        </div>
    </div>
}